export default "__VITE_ASSET__CTW6VBVk__"